import { ethers } from 'ethers'
import { parseInt } from 'lodash'
import { contractAddr, contractChainId } from '@/data/constants.js'
import { abi as contractAbi } from '@/data/TheQBits.json'
window.ethers = ethers

const WEB3_POLLING_INTERVAL = 1000

let checkConnectionTimeout = null

const web3Store = {
  state: {
    web3Modal: null,
    ethProvider: null,
    ethSigner: null,
    ethContractInstance: null,
    web3Connected: false,
    web3Account: null,
    web3ChainId: 0,
    web3LastChangeTimestamp: 0
  },
  mutations: {
    setWeb3Modal (state, payload) {
      state.web3Modal = payload
    },
    setEthProvider (state, payload) {
      state.ethProvider = payload
    },
    setEthSigner (state, payload) {
      state.ethSigner = payload
    },
    setEthContractInstance (state, payload) {
      state.ethContractInstance = payload
    },
    setWeb3Connected (state, payload) {
      state.web3Connected = payload
    },
    setWeb3Account (state, payload) {
      state.web3Account = payload
    },
    setWeb3ChainId (state, payload) {
      state.web3ChainId = payload
    },
    updateLastTimestamp (state) {
      state.web3LastChangeTimestamp = Date.now()
    }
  },
  getters: {
    web3Modal (state) {
      return state.web3Modal
    },
    ethProvider (state) {
      return state.ethProvider
    },
    ethSigner (state) {
      return state.ethSigner
    },
    ethContractInstance (state) {
      return state.ethContractInstance
    },
    web3Connected (state) {
      return state.web3Connected
    },
    web3Account (state) {
      return state.web3Account
    },
    web3ChainId (state) {
      return state.web3ChainId
    },
    web3ChainMatch (state) {
      return state.web3ChainId === contractChainId
    },
    web3LastChangeTimestamp (state) {
      return state.web3LastChangeTimestamp
    }
  },
  actions: {
    async web3Init ({ commit, dispatch }) {
      const ethProvider = ethers.providers.getDefaultProvider()
      ethProvider.pollingInterval = WEB3_POLLING_INTERVAL
      commit('setEthProvider', ethProvider)
      commit('setEthSigner', null)
      commit('setEthContractInstance', new ethers.Contract(contractAddr, contractAbi, ethProvider))
      const web3Network = await ethProvider.getNetwork()
      commit('setWeb3ChainId', web3Network.chainId)
      commit('setWeb3Account', null)
      commit('updateLastTimestamp')

      ethProvider.on('chainChanged', async web3ChainId => {
        commit('setWeb3ChainId', web3ChainId)
        commit('updateLastTimestamp')
      })
    },
    async web3InitModal ({ commit, dispatch }, web3Modal) {
      commit('setWeb3Modal', web3Modal)
      dispatch('web3Init')
    },
    async web3Connect ({ state, commit, dispatch }) {
      const web3Provider = await state.web3Modal.connect()
      const ethProvider = new ethers.providers.Web3Provider(web3Provider)
      ethProvider.pollingInterval = WEB3_POLLING_INTERVAL
      commit('setEthProvider', ethProvider)
      const ethSigner = ethProvider.getSigner()
      commit('setEthSigner', ethSigner)
      commit('setEthContractInstance', new ethers.Contract(contractAddr, contractAbi, ethSigner))

      const web3Accounts = await ethProvider.listAccounts()
      if (web3Accounts.length > 0) {
        commit('setWeb3Account', web3Accounts[0])
      }

      const web3Network = await ethProvider.getNetwork()
      commit('setWeb3ChainId', web3Network.chainId)
      commit('setWeb3Connected', true)
      commit('updateLastTimestamp')

      web3Provider.on('connect', async (info) => {
        const web3ChainId = parseInt(info.chainId)
        commit('setWeb3ChainId', web3ChainId)
        commit('updateLastTimestamp')
      })

      web3Provider.on('accountsChanged', async (web3Accounts) => {
        if (web3Accounts.length > 0) {
          commit('setWeb3Account', web3Accounts[0])
          commit('updateLastTimestamp')
        } else {
          await dispatch('web3ResetApp')
        }
      })

      web3Provider.on('chainChanged', async () => {
        dispatch('web3Connect')
      })

      const checkConnectionFunc = () => {
        ethSigner.getAddress()
          .then(address => {
            if (!address) { throw new Error('T8 Address failed') }
            checkConnectionTimeout = setTimeout(checkConnectionFunc, 2000)
          })
          .catch(() => {
            dispatch('web3ResetApp')
          })
      }
      checkConnectionFunc()
    },
    async web3ResetApp ({ state, dispatch }) {
      if (checkConnectionTimeout) {
        clearTimeout(checkConnectionTimeout)
      }
      try {
        await state.web3Modal.clearCachedProvider()
      } catch (error) {
        console.error(error) // eslint-disable-line no-console
      }
      dispatch('web3Init')
    },
    async web3SwitchChain ({ state, dispatch }) {
      if (state.ethProvider) {
        const contractChainIdHex = ethers.BigNumber.from(contractChainId).toHexString()
        state.ethProvider
          .send('wallet_switchEthereumChain', [{ chainId: contractChainIdHex }])
          .catch(() => {
            return state.ethProvider
              .send('wallet_addEthereumChain', [{ chainId: contractChainIdHex }])
          })
          .catch(error => {
            dispatch('web3Connect')
            console.error(error) // eslint-disable-line no-console
            dispatch('alertShow', { error: 'T8 Unable to switch network' })
          })
      }
    },
    async web3SwitchAccount ({ state, dispatch }) {
      if (state.ethProvider) {
        try {
          await state.web3Modal.clearCachedProvider()
          await state.ethProvider.send('wallet_requestPermissions', [
            {
              eth_accounts: {}
            }
          ])
        } catch (error) {
          dispatch('web3Connect')
          console.error(error) // eslint-disable-line no-console
          dispatch('alertShow', { error: 'T8 Unable to switch account' })
        }
      }
    }
  }
}
export default web3Store
